var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.dukandarInvoice),function(invoice2){return _c('invoice-item',{key:invoice2.myDate,attrs:{"invoice":invoice2,"myUserIdProps":_vm.returnUserId}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }